import hljs from 'highlight.js/lib/core';
import javascript from 'highlight.js/lib/languages/javascript';
import json from 'highlight.js/lib/languages/json';
import css from 'highlight.js/lib/languages/css';
import xml from 'highlight.js/lib/languages/xml';
import markdown from 'highlight.js/lib/languages/markdown';
import php from 'highlight.js/lib/languages/php';
import sql from 'highlight.js/lib/languages/sql';
import shell from 'highlight.js/lib/languages/shell';
import bash from 'highlight.js/lib/languages/bash';

export const supportedLanguages = {
  javascript,
  json,
  css,
  xml,
  markdown,
  php,
  sql,
  shell,
  bash
};

Object.keys(supportedLanguages).forEach((lang) =>
  hljs.registerLanguage(lang, supportedLanguages[lang])
);

export default hljs;

const lang2hljsMap = {
  html: 'xml',
  sh: 'shell'
};

export const highlight = ({ code, lang }) =>
  hljs.highlight(code, { language: lang2hljsMap[lang] ?? lang }).value;
